import Hotjar from '@hotjar/browser'
import { computed, watch } from 'vue';
import { useAppStore } from '@/stores/app.store';
import { CwxBackend } from '@/types/cwxBackend';

export function useHotjar() {
  const hotjarVersion = 6;
  const appStore = useAppStore();

  function initializeHotjar(): void {
    const appStore = useAppStore();
    const systemSettings: CwxBackend.ISystemSettingsDto = computed(() => appStore.systemSettings).value;

    if (systemSettings?.isHotjarEnabled && systemSettings?.hotjarSiteId?.length > 0) {
      Hotjar.init(Number(systemSettings.hotjarSiteId), hotjarVersion, {
        debug: true,
      });
    }
  }

  watch(
    () => appStore.systemSettings,
    () => {
      initializeHotjar();
    },

  );
}




